import React from 'react';

import { YouTubeUrl as YouTubeUrlForm } from '@/components/Layout/components/AddCustomSong/YouTubeUrl';

import { IPropsSongModalDisplay } from '../SongModalPanel';

export const YouTubeUrl: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	updateTeamSong,
	popDisplayState,
}) => {
	return (
		<YouTubeUrlForm
			teamSong={openedSong}
			onSubmit={({ youtubeId }) => {
				updateTeamSong({ youtubeId });
				popDisplayState();
			}}
		/>
	);
};
